<div class="flex relative min-h-10">
    <input
        #inputElement
        [disabled]="disabled"
        class="input flex-1 py-2 pe-8 ps-4 typography-body-m-regular border border-border-secondary"
        [ngClass]="{'text-text-tertiary': !value, 'text-text-primary': value}"
        type="text"
        [placeholder]="placeholder | translate"
        [ngModel]="value"
        (ngModelChange)="onInternalChange($event)"
        (keydown.enter)="onEnter($event)"
        (blur)="onBlur()"
    />
    <div
        *ngIf="!searchDisabled"
        class="absolute ltr:right-2 rtl:left-2 top-0 bottom-0 flex items-center cursor-pointer"
        (click)="inputElement.focus()"
    >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.4748 20.15L13.2248 13.9C12.7248 14.3167 12.1498 14.6417 11.4998 14.875C10.8498 15.1084 10.1998 15.225 9.5498 15.225C7.93314 15.225 6.5708 14.6707 5.4628 13.562C4.35414 12.454 3.7998 11.1 3.7998 9.50002C3.7998 7.90002 4.35414 6.54569 5.4628 5.43702C6.5708 4.32902 7.9248 3.77502 9.5248 3.77502C11.1248 3.77502 12.4831 4.32902 13.5998 5.43702C14.7165 6.54569 15.2748 7.90002 15.2748 9.50002C15.2748 10.2 15.1498 10.875 14.8998 11.525C14.6498 12.175 14.3248 12.725 13.9248 13.175L20.1998 19.45L19.4748 20.15ZM9.5498 14.225C10.8665 14.225 11.9831 13.771 12.8998 12.863C13.8165 11.9544 14.2748 10.8334 14.2748 9.50002C14.2748 8.16669 13.8165 7.04569 12.8998 6.13702C11.9831 5.22902 10.8665 4.77502 9.5498 4.77502C8.21647 4.77502 7.09147 5.22902 6.1748 6.13702C5.25814 7.04569 4.7998 8.16669 4.7998 9.50002C4.7998 10.8334 5.25814 11.9544 6.1748 12.863C7.09147 13.771 8.21647 14.225 9.5498 14.225Z" fill="#232323"></path></svg>
    </div>
</div>
